var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen"},[(_vm.isLoading)?_c('LoadingSpinner'):_c('div',{staticClass:"html"},[_c('iframe',{attrs:{"srcdoc":_vm.modifiedHTML}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }